import { useState, useCallback } from 'react';
import { GetAllPromotions } from '../services/api/methods.ts';
import { Promotion, GetAllPromotionsResult } from '../services/api/types.ts';

export const usePromotion = () => {
    const [promotion, setPromotion] = useState<Promotion[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const loadPromotions = useCallback(async () => {
        setLoading(true);
        setError('');

        try {
            const result = await GetAllPromotions();
            setPromotion(result.Promotions);
        } catch (err: any) {
            setError('Ошибка при загрузке сессий');
            console.error('Ошибка при загрузке сессий:', err);
        } finally {
            setLoading(false);
        }
    }, []);

    return {
        promotion,
        loading,
        error,
        loadPromotions,
        setPromotion,
        setError
    };
};
